import { getTokenFromLocal, handleResponse } from '../../_helpers/handleResponseMiddleware';

const centralBaseUrl = process.env.REACT_APP_CENTRAL_BASE_URL;

/**
 * Returns auth headers for AR Reconciliation API calls.
 * Token is always read dynamically from localStorage — never hardcoded.
 */
function arAuthHeaders() {
  const user = getTokenFromLocal();
  const token = user?.access_token || null;
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    appname: 'Hospital Web Chat',
  };
}

/**
 * 1. Fetch AR Status Data for a hospital.
 * @param {Object} params
 * @param {string} params.hospitalId         - Hospital unique identifier (required)
 * @param {string} [params.hospitalStatus]   - 'approve' | 'dispute' | omit for open/pending cases
 */
export function getArStatusDataService({ hospitalId, hospitalStatus } = {}) {
  const query = new URLSearchParams();
  query.append('hospitalId', hospitalId);
  if (hospitalStatus) query.append('hospitalStatus', hospitalStatus);

  return fetch(`${centralBaseUrl}/getArStatusData?${query.toString()}`, {
    method: 'GET',
    headers: arAuthHeaders(),
  })
    .then(handleResponse)
    .catch((error) => {
      console.error('getArStatusDataService error:', error);
      throw error;
    });
}

/**
 * 2. Fetch Detailed Appointment Bill Information by appId.
 * @param {string} appId - Appointment ID
 */
export function getAppointmentBillInfoService(appId) {
  return fetch(`${centralBaseUrl}/getAppointmentBillInfo?appId=${encodeURIComponent(appId)}`, {
    method: 'GET',
    headers: arAuthHeaders(),
  })
    .then(handleResponse)
    .catch((error) => {
      console.error('getAppointmentBillInfoService error:', error);
      throw error;
    });
}

/**
 * 3. Update AR Status (Sign Off or Raise Dispute).
 * @param {Object} payload
 * @param {string} payload.appId          - Appointment ID
 * @param {string} payload.hospitalId     - Hospital ID
 * @param {string} payload.hospitalStatus - 'approve' for Sign off | 'dispute' for Raise dispute
 * @param {string} [payload.remark]       - Reason / notes
 */
export function updateArStatusService({ appId, hospitalId, hospitalStatus, remark = '' }) {
  return fetch(`${centralBaseUrl}/updateArStatus`, {
    method: 'POST',
    headers: arAuthHeaders(),
    body: JSON.stringify({
      appId,
      hospitalId,
      hospitalStatus,
      remark: remark || (hospitalStatus === 'approve' ? 'Approved by hospital' : 'Dispute raised by hospital'),
    }),
  })
    .then(handleResponse)
    .catch((error) => {
      console.error('updateArStatusService error:', error);
      throw error;
    });
}
